import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "acre-cookie-consent__wrapper" }
const _hoisted_2 = { class: "acre-cookie-consent__text" }
const _hoisted_3 = { class: "acre-cookie-consent__buttons" }
const _hoisted_4 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Transition, { name: "fade-change" }, {
    default: _withCtx(() => [
      (_ctx.showPopup)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "AcreCookieConsent acre-cookie-consent",
            style: _normalizeStyle({ maxWidth: `${_ctx.maxWidthContainer}px` })
          }, [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.message), 1),
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("a", {
                  href: _ctx.linkHref,
                  class: "acre-cookie-consent__button is--outlined-gray"
                }, _toDisplayString(_ctx.linkText), 9, _hoisted_4),
                _createElementVNode("button", {
                  class: "acre-cookie-consent__button is--white",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.acceptConsentBanner && _ctx.acceptConsentBanner(...args)))
                }, _toDisplayString(_ctx.dismissButtonText), 1)
              ])
            ])
          ], 4))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}